import { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Link from '../Link'
import { truncate } from '../../utils/string'
export default class NotificationListItem extends Component {
  handleSelection = () => {
    const { notification, checked, onSelect } = this.props
    onSelect(notification, !checked)
  }

  render() {
    const { notification, checked } = this.props
    const notificationId = notification.id
    const inputId = `notification_ids_${notificationId}`
    const modifier = notification.is_read ? 'notification-item--read' : 'notification-item--unread'
    const href = `notifications/${notificationId}`
    return (
      <li className={classnames('notification-item', modifier)}>
        <input
          id={inputId}
          name="notification_ids[]"
          type="checkbox"
          checked={checked}
          value={notificationId}
          onClick={this.handleSelection}
          readOnly
        />
        <Link href={href}>
          <span
            className="notification-item__subject"
            dangerouslySetInnerHTML={{ __html: truncate(notification.subject, 50) }}
          />
          <span
            className="notification-item__body"
            dangerouslySetInnerHTML={{ __html: truncate(notification.body, 120) }}
          />
          <span className="notification-item__received-at">{notification.listing_date}</span>
        </Link>
      </li>
    )
  }
}

NotificationListItem.propTypes = {
  checked: PropTypes.bool.isRequired,
  notification: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired,
}
